import { useState, useEffect } from 'react';
import { Button } from './Button';

const APP_STORE_URL = 'https://www.nuvemshop.com.br/loja-de-aplicativos/';

export function StickyHeader() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector('.section-hero');
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: 'var(--header-height)',
        backgroundColor: 'rgba(26,26,46,0.95)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        zIndex: 1000,
        transform: visible ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 300ms ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--spacing-md)',
        boxSizing: 'border-box',
      }}
    >
      {/* Logo dark variant -- inline SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 190 44"
        width={120}
        height={28}
        aria-label="Assine"
        role="img"
      >
        <g transform="translate(4, 2)">
          <rect x="0" y="18" width="7.5" height="18" rx="3.75" fill="#A855F7" />
          <rect x="10" y="10" width="7.5" height="26" rx="3.75" fill="#E84393" />
          <rect x="20" y="2" width="7.5" height="34" rx="3.75" fill="#FF6B6B" />
          <path
            d="M31 12 L33.5 7 L36 12"
            stroke="#FF8E53"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <line
            x1="33.5"
            y1="7"
            x2="33.5"
            y2="17"
            stroke="#FF8E53"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <text
          x="52"
          y="31"
          fontFamily="Nunito, -apple-system, BlinkMacSystemFont, sans-serif"
          fontWeight="800"
          fontSize="28"
          letterSpacing="-0.02em"
          fill="#F0F0F5"
        >
          assine
        </text>
      </svg>

      <Button variant="gradient" href={APP_STORE_URL}>
        Instalar no Nuvemshop
      </Button>
    </header>
  );
}
